"use client";
import * as React from "react";
const SvgLightbulbFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 11 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.143 15.2c0 .4.314.8.786.8H7.07c.472 0 .786-.4.786-.8v-.8H3.143v.8ZM5.5 0C2.436 0 0 2.48 0 5.6c0 1.92.943 3.6 2.357 4.56V12c0 .4.314.8.786.8h4.714c.472 0 .786-.4.786-.8v-1.84C10.057 9.12 11 7.44 11 5.6 11 2.48 8.564 0 5.5 0Z" }));
export {
  SvgLightbulbFilled as default
};
